import { render } from "./FormVenta.vue?vue&type=template&id=728ebb7e&scoped=true"
import script from "./FormVenta.vue?vue&type=script&lang=js"
export * from "./FormVenta.vue?vue&type=script&lang=js"

import "./FormVenta.vue?vue&type=style&index=0&id=728ebb7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728ebb7e"]])

export default __exports__